<template>
  <div>
    <el-radio-group style="margin-bottom: 7px;" v-model="period">
      <el-radio label="N">한번만</el-radio>
      <el-radio label="D">매일</el-radio>
      <el-radio label="W">매주</el-radio>
      <el-radio label="M">매월</el-radio>
    </el-radio-group>

    <el-row v-show="period === 'N'" type="flex" justify="start">
      <el-col>
        <div class="title-popup-s">스케줄 실행 날짜</div>
        <el-date-picker v-model="onceData.scheduleStarttime" type="date" placeholder="스케줄 실행 날짜" />
      </el-col>
      <el-col>
        <w-time-selection-component class="title-popup-s" ref="onceTime" title="실행 시간" :executeHour="onceData.scheduleHour" :executeMinute="onceData.scheduleMinute" />
      </el-col>
    </el-row>

    <div class="setting-checkbox" v-show="period === 'D'">
      <div class="title-popup-s">스케줄 실행 시간</div>
      <el-checkbox-group  style="margin-bottom: 20px;" v-model="dailyData.scheduleIntervalHour">
        <el-checkbox-button style="width: 40px;" v-for="time in TIME" :key="time.time" :label="(time.time).toString()">{{time.label}}시</el-checkbox-button>
      </el-checkbox-group>
    </div>

    <div class="setting-checkbox" v-show="period === 'W'">
      <div class="title-popup-s">스케줄 실행 요일</div>
      <el-checkbox-group v-show="weeklyData.scheduleIntervalDate.length > 0" style="margin-bottom: 20px;" v-model="weeklyData.scheduleIntervalDate">
        <el-checkbox-button v-for="day in WEEK" :key="day.week" :label="(day.week+1).toString()">{{day.label}}</el-checkbox-button>
      </el-checkbox-group>
      <w-time-selection-component ref="weeklyTime" title="실행 시간" :executeHour="weeklyData.scheduleHour" :executeMinute="weeklyData.scheduleMinute" />
    </div>

    <div v-show="period === 'M'">
      <el-row style="margin-bottom: 20px;" type="flex" justify="start">
        <el-col>
          <div class="title-popup-s">스케줄 실행 월</div>
          <el-select v-model="monthlyData.scheduleIntervalMonth" multiple collapse-tags placeholder="월">
            <el-option v-for="month in MONTH" :key="month.value" :label="month.label" :value="(month.value).toString()" />
          </el-select>
        </el-col>
        <el-col>
          <div class="title-popup-s">스케줄 실행 일</div>
          <el-select v-model="monthlyData.scheduleIntervalDate" multiple collapse-tags placeholder="일">
            <el-option v-for="date in 31" :key="date" :label="date" :value="date.toString()" />
            <el-option key="E" label="마지막날" value="E" />
          </el-select>
        </el-col>
      </el-row>

      <w-time-selection-component ref="monthlyTime" title="실행 시간" :executeHour="monthlyData.scheduleHour" :executeMinute="monthlyData.scheduleMinute" />
    </div>
  </div>
</template>

<script>
import sortBy from 'lodash/sortBy';
import keys from 'lodash/keys';
import clone from 'lodash/clone';

import { WEEK, MONTH, TIME } from '@/constants/date';
import WTimeSelectionComponent from './TimeSelectionComponent';

const onceInitData = {
  scheduleStarttime: new Date(),
  scheduleHour: 0,
  scheduleMinute: 0,
};
const dailyInitData = {
  scheduleIntervalHour: ['0', '3', '6', '9', '12', '15', '18', '21'],
};
const weeklyInitData = {
  scheduleIntervalDate: ['1', '2', '3', '4', '5', '6', '7'],
  scheduleHour: 0,
  scheduleMinute: 0,
};
const monthlyInitData = {
  scheduleIntervalMonth: ['1'],
  scheduleIntervalDate: ['1'],
  scheduleHour: 0,
  scheduleMinute: 0,
};

export default {
  name: 'WPeriodSettingComponent',
  components: {
    WTimeSelectionComponent,
  },
  data() {
    return {
      WEEK,
      MONTH,
      TIME,
      period: 'D',
      onceData: {},
      dailyData: {
        scheduleIntervalHour: [],
      },
      weeklyData: {
        scheduleIntervalDate: [],
      },
      monthlyData: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.period = 'D';
      this.onceData = clone(onceInitData);
      this.dailyData = clone(dailyInitData);
      this.weeklyData = clone(weeklyInitData);
      this.monthlyData = clone(monthlyInitData);
      this.$refs.onceTime.init();
      this.$refs.weeklyTime.init();
      this.$refs.monthlyTime.init();
    },
    /**
     * 주기 설정 데이터를 리턴한다.
     * @return {[type]} [description]
     * @author jda
     */
    getPeriodSettingData() {
      const schedulePeriod = this.period;
      if (schedulePeriod === 'N') {
        const selectionTime = this.$refs.onceTime.getSelectionTime();
        const starttime = new Date(this.onceData.scheduleStarttime);
        starttime.setHours(selectionTime.hour, selectionTime.minute, 0, 0);

        return {
          schedulePeriod,
          scheduleStarttime: starttime.getTime(),
        };
      } else if (schedulePeriod === 'D') {
        return {
          schedulePeriod,
          scheduleIntervalHour: sortBy(this.dailyData.scheduleIntervalHour, (interval) => parseInt(interval, 10)).toString(),
        };
      } else if (schedulePeriod === 'W') {
        const selectionTime = this.$refs.weeklyTime.getSelectionTime();

        return {
          schedulePeriod,
          scheduleIntervalDate: sortBy(this.weeklyData.scheduleIntervalDate, (interval) => parseInt(interval, 10)).toString(),
          scheduleHour: selectionTime.hour,
          scheduleMinute: selectionTime.minute,
        };
      } else if (schedulePeriod === 'M') {
        const selectionTime = this.$refs.monthlyTime.getSelectionTime();
        const monthlyData = this.monthlyData;

        return {
          schedulePeriod,
          scheduleIntervalMonth: sortBy(monthlyData.scheduleIntervalMonth, (interval) => parseInt(interval, 10)).toString(),
          scheduleIntervalDate: sortBy(monthlyData.scheduleIntervalDate, (interval) => parseInt(interval, 10)).toString(),
          scheduleHour: selectionTime.hour,
          scheduleMinute: selectionTime.minute,
        };
      }
      return null;
    },
    /**
     * 수집 주기 편집에서 주기 설정 데이터를 바인딩한다.
     * @param  {[type]} record [description]
     * @author jda
     */
    setPeriodSettingData(record) {
      const schedulePeriod = record.schedulePeriod;
      this.period = schedulePeriod;

      if (schedulePeriod === 'N') {
        const scheduleStarttime = record.scheduleStarttime;
        const starttime = new Date(scheduleStarttime);
        this.onceData = {
          scheduleStarttime,
          scheduleHour: starttime.getHours(),
          scheduleMinute: starttime.getMinutes(),
        };
      } else if (schedulePeriod === 'D') {
        this.dailyData = {
          scheduleIntervalHour: record.scheduleIntervalHour.split(','),
        };
      } else if (schedulePeriod === 'W') {
        this.weeklyData = {
          scheduleIntervalDate: record.scheduleIntervalDate.split(','),
          scheduleHour: record.scheduleHour,
          scheduleMinute: record.scheduleMinute,
        };
      } else if (schedulePeriod === 'M') {
        this.monthlyData = {
          scheduleIntervalMonth: record.scheduleIntervalMonth.split(','),
          scheduleIntervalDate: record.scheduleIntervalDate.split(','),
          scheduleHour: record.scheduleHour,
          scheduleMinute: record.scheduleMinute,
        };
      }
    },
    /**
     * 주기에 해당하는 각 key들을 리턴한다.
     * 수집 주기 편집시 사용.
     * @param  {[type]} period [description]
     * @return {[type]}        [description]
     * @author jda
     */
    getKeysByPeriod(period) {
      if (period === 'N') {
        return keys(this.onceData);
      } else if (period === 'D') {
        return keys(this.dailyData);
      } else if (period === 'W') {
        return keys(this.weeklyData);
      } else if (period === 'M') {
        return keys(this.monthlyData);
      }
      return null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/components/VmsPeriodSettingComponent.vue